import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionHotelPolicyCheckInAndCheckOut } from "./check-in-and-check-out";
import { QuestionHotelPolicyHotelInfo } from "./hotel-info";
import { QuestionReservationRequiredPrepMilli } from "./required-prep-milli";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	base: HotelPolicyCategoriesAndManagerStore["base"];
};

export const QuestionHotelPolicyBase = ({ base }: Props) => {
	return (
		<>
			<FeatureIslandMainWithCategoryWrapper categoryStore={base} islandTitle={"施設の基本設定"}>
				<QuestionHotelPolicyCheckInAndCheckOut />
				<QuestionReservationRequiredPrepMilli />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper
				categoryStore={base}
				islandTitle={"施設に関する注意事項（よくある質問 Q&A）"}
			>
				<QuestionHotelPolicyHotelInfo />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionHotelPolicyBase.displayName = "QuestionHotelPolicyBase";
